import { List } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { ChevronLeft, Tick } from '@yy/one-icon'
import type { LanguageType } from '@/constant/language'
import { useLanguage } from '@/hooks/useLanguage'
import { useSelector } from '@/store'
import { changeLanguage } from '@/store/languageSlice'
import styles from './index.module.less'

interface PropsType {
  setSubMenu?: (val: boolean) => void
  setLangOpen?: (val: boolean) => void
  closeAll: () => void
}
const Language: React.FC<PropsType> = (props: PropsType) => {
  const { setSubMenu, setLangOpen, closeAll } = props
  const languageStore = useSelector((state) => state.language)
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()

  const handleBack = () => {
    setLangOpen(false)
    setSubMenu(true)
  }

  const lanageChange = async (lang: LanguageType) => {
    dispatch(changeLanguage(lang))
    i18n.changeLanguage(lang.lang)
    closeAll()
  }

  const { languageList } = useLanguage()

  return (
    <div className={styles.container}>
      <List className={styles.list}>
        <List.Item key={'country-return'} onClick={handleBack}>
          <div className={styles.back}>
            <ChevronLeft className={styles.icon} />
            <span>{t('wallet.login.back')}</span>
          </div>
        </List.Item>
        {languageList.map((lang) => {
          return (
            <List.Item
              className={`${lang.languageType === languageStore.languageType ? styles.active : ''}`}
              key={lang.label}
              onClick={lanageChange.bind(null, lang)}
              data-id={`user-language-menu-${lang.label}`}
              id={`user-language-menu-${lang.label}`}
            >
              <span className={styles.text}>{lang.label}</span>
              {lang.languageType === languageStore.languageType && <Tick style={{ fontSize: 16, marginRight: '16px' }} stroke={'#02C8C6'} />}
            </List.Item>
          )
        })}
      </List>
    </div>
  )
}

Language.displayName = 'Language'
export default Language
